module.exports = __webpack_public_path__ + "img/2.10c48132.svg";